import { PropsWithChildren } from 'react'

import styles from 'layout/fullHeightPage/FullHeightPage.module.scss'

export const FullHeightPage = ({ children }: PropsWithChildren<{}>) => <div className={styles.root}>{children}</div>
